import { FC, ReactElement, useContext } from 'react';
import { Dropdown, Button } from 'antd';
import { NotificationContext } from 'context/NotificationContext';
import TooltipPopover from 'components/TooltipPopover/TooltipPopover';
import { SPANISH_MODE_PLAN_MANAGEMENT_TOOLTIP } from 'constants/commonConstants';
import styles from './planSelectButton.module.less';

type PlanSelectButtonProps = {
  overlay: ReactElement;
  selectLabel: string;
  className?: string;
  disabled?: boolean;
};

const PlanSelectButton: FC<PlanSelectButtonProps> = (
  props: PlanSelectButtonProps
) => {
  const {
    overlay,
    selectLabel,
    className = styles.dropdownButton,
    disabled = false,
  } = props;
  const notificationFlag = useContext(NotificationContext);

  return (
    <Dropdown
      disabled={notificationFlag || disabled}
      overlay={overlay}
      trigger={['click']}
      overlayClassName={styles.planDropdownMenu}
      getPopupContainer={(triggerNode) =>
        triggerNode.parentElement ? triggerNode.parentElement : triggerNode
      }
    >
      <TooltipPopover
        content={SPANISH_MODE_PLAN_MANAGEMENT_TOOLTIP}
        visible={disabled ? undefined : false}
        style={{ backgroundColor: 'red' }}
        className={styles.tooltipOverlay}
        placement="top"
      >
        <Button
          disabled={notificationFlag || disabled}
          onClick={(e) => e.preventDefault()}
          className={className}
        >
          {selectLabel}
        </Button>
      </TooltipPopover>
    </Dropdown>
  );
};

export default PlanSelectButton;
